// Angular
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
// Tranlsation
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export interface Locale {
  lang: string;
  // tslint:disable-next-line:ban-types
  data: Object;
}

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  // Private properties
  private langIds: any = [];

  langSubject = new BehaviorSubject('');

  /**
   * Service Constructor
   *
   * @param translate: TranslateService
   */
  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    // add new langIds to the list
    this.translate.addLangs(['en']);
    this.translate.addLangs(['fr']);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('fr');
  }

  get onLangChange() {
    return this.translate.onLangChange;
  }

  /**
   * Load Translation
   *
   * @param args: Locale[]
   */
  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach((locale) => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);

      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
  }

  /**
   * Setup language
   *
   * @param lang: any
   */
  setLanguage(lang, isChangeLangBtn?: boolean): any {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('language', lang);
        isChangeLangBtn ? this.langSubject.next(lang) : null;
      }
    }
  }

  /**
   * Returns selected language
   */
  getSelectedLanguage(): any {
    if (isPlatformBrowser(this.platformId)) {
      return (
        localStorage.getItem('language') || this.translate.getDefaultLang()
      );
    }
  }

  getLanguages(): any {
    return this.translate.getLangs();
  }
}
